import { UpdatePartnerNewsRequestSchema, UpdatePartnerNewsResponseSchema } from './update-partner-news.schema';
export const updatePartnerNewsContract = {
    method: 'PATCH',
    path: '/api/v2/admin/partner-news/:id',
    description: 'Update a partner news entry',
    requestSchema: UpdatePartnerNewsRequestSchema,
    responseSchema: UpdatePartnerNewsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - invalid input data',
            401: 'Unauthorized - user not authenticated',
            403: 'Forbidden - superadmin only',
            404: 'Partner news not found'
        }
    }
};

//# sourceMappingURL=update-partner-news.contract.js.map